(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('CareCoordinationTemplate', CareCoordinationTemplate);

    CareCoordinationTemplate.$inject = ['$resource'];

    function CareCoordinationTemplate ($resource) {
        var resourceUrl =  'api/care-coordination-templates/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByFilter': {url: "api/care-coordination-templates/filter", method: 'GET', isArray: true}
        });
    }
})();
